import type { Character } from '@/types'

export function CharacterChip({ character }: { character: Pick<Character, 'name' | 'color'> }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wide">
      <span className="size-2 rounded-full" style={{ backgroundColor: character.color }} />
      {character.name}
    </span>
  )
}
